module.exports = __webpack_public_path__ + "assets/img/loader.5854f5a6.svg";